<template>
    <v-container>
        <v-card class="elevation-12" width='100%'>
            <v-toolbar color="primary" dark>
                <v-card-title>
                    <v-icon color="white">mdi-auto-fix</v-icon>&nbsp; Data fixer
                </v-card-title>
            </v-toolbar> 
            <v-card-text>
                <Datafixerform/>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script lang="ts">
    import Vue from 'vue'
    import Datafixerform from './Datafixerform.vue';
    export default Vue.extend({
        name: 'Datafixer',
        components:{
            Datafixerform
        }
    })
</script>